export default __webpack_public_path__ + "static/media/banner-three.5623c27f.jpg";